export const settings = {
  // API_HOST: "https://derbyshire-pep.org.uk",
  API_HOST: "https://test.assetforschools.com",
  CORS_ALLOWED_ORIGINS: "",
};
